import apiClient from './apiClient';

export const createPayment = async (orderId) => {
  try {
    const response = await apiClient.post('/payments/create/', { order_id: orderId });
    return response.data;
  } catch (error) {
    console.error('Error creating payment:', error.response?.data || error.message);
    throw new Error(
      error.response?.data?.error || 
      error.response?.data?.message || 
      'Error al crear el pago. Por favor, inténtelo de nuevo.'
    );
  }
};

export const getPaymentStatus = async (orderId) => {
  try {
    const response = await apiClient.get(`/payments/status/${orderId}/`);
    return response.data;
  } catch (error) {
    console.error('Error getting payment status:', error.response?.data || error.message);
    throw new Error(
      error.response?.data?.error || 
      error.response?.data?.message || 
      'Error al obtener el estado del pago.'
    );
  }
};

export const checkMercadoPagoStatus = async (/* paymentId */) => {
  try {
    // Esta función podría implementarse si se necesita verificar
    // directamente con MercadoPago el estado de un pago
    console.error('checkMercadoPagoStatus is not implemented yet');
    // Aquí se podría hacer una llamada a la API de MercadoPago
    return null;
  } catch (error) {
    // This code is kept for future implementation
    // but modified to avoid the unreachable code error
    console.error('Error checking MercadoPago status:', error);
  }
};

// Función para actualizar manualmente la tasa de dólar desde DolarAPI
export const updateDollarRateFromAPI = async (rateType = 'blue') => {
  try {
    const response = await apiClient.get(`/payments/update-dollar-rate/?rate_type=${rateType}`);
    return response.data;
  } catch (error) {
    console.error('Error updating dollar rate from API:', error.response?.data || error.message);
    throw new Error(
      error.response?.data?.error || 
      error.response?.data?.message || 
      'Error al actualizar la tasa del dólar desde la API externa.'
    );
  }
};

// Funciones para manejar tasas de dólar
export const getCurrentDollarRate = async () => {
  try {
    const response = await apiClient.get('/payments/dollar-rates/?is_active=true');
    
    // Verificar si la respuesta tiene un formato paginado o no
    if (response.data.results && Array.isArray(response.data.results)) {
      // Respuesta paginada
      return response.data.results.length > 0 ? response.data.results[0] : null;
    } else if (Array.isArray(response.data)) {
      // Respuesta como array directo
      return response.data.length > 0 ? response.data[0] : null;
    }
    
    return null;
  } catch (error) {
    console.error('Error getting dollar rate:', error.response?.data || error.message);
    throw new Error(
      error.response?.data?.error || 
      error.response?.data?.message || 
      'Error al obtener la tasa del dólar.'
    );
  }
};

export const createDollarRate = async (dollarRateData) => {
  try {
    const response = await apiClient.post('/payments/dollar-rates/', dollarRateData);
    return response.data;
  } catch (error) {
    console.error('Error creating dollar rate:', error.response?.data || error.message);
    throw new Error(
      error.response?.data?.error || 
      error.response?.data?.message || 
      'Error al crear la tasa del dólar.'
    );
  }
};

export const updateDollarRate = async (id, dollarRateData) => {
  try {
    const response = await apiClient.patch(`/payments/dollar-rates/${id}/`, dollarRateData);
    return response.data;
  } catch (error) {
    console.error('Error updating dollar rate:', error.response?.data || error.message);
    throw new Error(
      error.response?.data?.error || 
      error.response?.data?.message || 
      'Error al actualizar la tasa del dólar.'
    );
  }
};

// Funciones para manejar centros de distribución
export const getDistributionCenters = async () => {
  try {
    const response = await apiClient.get('/payments/distribution-centers/');
    
    // Verificar si la respuesta tiene un formato paginado o no
    if (response.data.results && Array.isArray(response.data.results)) {
      // Respuesta paginada
      return response.data.results;
    } else if (Array.isArray(response.data)) {
      // Respuesta como array directo
      return response.data;
    }
    
    // Si no es un array, retornar array vacío
    return [];
  } catch (error) {
    console.error('Error getting distribution centers:', error.response?.data || error.message);
    throw new Error(
      error.response?.data?.error || 
      error.response?.data?.message || 
      'Error al obtener los centros de distribución.'
    );
  }
};

export const createDistributionCenter = async (centerData) => {
  try {
    const response = await apiClient.post('/payments/distribution-centers/', centerData);
    return response.data;
  } catch (error) {
    console.error('Error creating distribution center:', error.response?.data || error.message);
    throw new Error(
      error.response?.data?.error || 
      error.response?.data?.message || 
      'Error al crear el centro de distribución.'
    );
  }
};

export const updateDistributionCenter = async (id, centerData) => {
  try {
    const response = await apiClient.patch(`/payments/distribution-centers/${id}/`, centerData);
    return response.data;
  } catch (error) {
    console.error('Error updating distribution center:', error.response?.data || error.message);
    throw new Error(
      error.response?.data?.error || 
      error.response?.data?.message || 
      'Error al actualizar el centro de distribución.'
    );
  }
};

export const deleteDistributionCenter = async (id) => {
  try {
    const response = await apiClient.delete(`/payments/distribution-centers/${id}/`);
    return response.data;
  } catch (error) {
    console.error('Error deleting distribution center:', error.response?.data || error.message);
    throw new Error(
      error.response?.data?.error || 
      error.response?.data?.message || 
      'Error al eliminar el centro de distribución.'
    );
  }
};

// Función para procesar un reembolso de pago
export const refundPayment = async (orderId) => {
  try {
    const response = await apiClient.post('/payments/refund/', { order_id: orderId });
    return response.data;
  } catch (error) {
    console.error('Error processing refund:', error.response?.data || error.message);
    throw new Error(
      error.response?.data?.error || 
      error.response?.data?.message || 
      'Error al procesar el reembolso. Por favor, inténtelo de nuevo.'
    );
  }
};
